import { Tokens } from '@/assets/tokens'
import styled from 'styled-components'

export const TooltipContent = styled.div<{ $top: number; $left: number }>`
  width: max-content;
  max-width: 440px;
  background-color: ${Tokens.ColorBackground};
  color: ${Tokens.ColorTextPrimary};
  text-align: left;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);

  position: fixed;
  top: ${(props) => props.$top}px;
  left: ${(props) => props.$left}px;
  transform: translateY(-50%);
  pointer-events: none;

  animation: fadeIn 0.2s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-50%) translateX(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  }

  &::after {
    content: '';
    position: absolute;
    border-width: 5px;
    border-style: solid;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    border-color: transparent ${Tokens.ColorBackground} transparent transparent;
  }
`

export const TooltipContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
